/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/auth': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['AuthRequest'];
          'text/json': components['schemas']['AuthRequest'];
          'application/*+json': components['schemas']['AuthRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['AuthResult'];
            'application/json': components['schemas']['AuthResult'];
            'text/json': components['schemas']['AuthResult'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/auth/updatesastoken': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['AuthRequest'];
          'text/json': components['schemas']['AuthRequest'];
          'application/*+json': components['schemas']['AuthRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SasTokenResult'];
            'application/json': components['schemas']['SasTokenResult'];
            'text/json': components['schemas']['SasTokenResult'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/authentication/login': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['LoginRequest'];
          'text/json': components['schemas']['LoginRequest'];
          'application/*+json': components['schemas']['LoginRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['AccessTokenResponse'];
            'application/json': components['schemas']['AccessTokenResponse'];
            'text/json': components['schemas']['AccessTokenResponse'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Unauthorized */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/authentication/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['RefreshRequest'];
          'text/json': components['schemas']['RefreshRequest'];
          'application/*+json': components['schemas']['RefreshRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['AccessTokenResponse'];
            'application/json': components['schemas']['AccessTokenResponse'];
            'text/json': components['schemas']['AccessTokenResponse'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ValidationProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ValidationProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ValidationProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Unauthorized */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/cfproxy/post': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': unknown;
          'text/json': unknown;
          'application/*+json': unknown;
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/customer/{customerId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          customerId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          customerId: number;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreditCardTokenInputDTO'];
          'text/json': components['schemas']['CreditCardTokenInputDTO'];
          'application/*+json': components['schemas']['CreditCardTokenInputDTO'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          customerId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/billinggroup/id/{billingGroupId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          billingGroupId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/billinggroup/customer/{masterCustomerId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          masterCustomerId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/location/{locationId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          locationId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/billinggroup/{mastercustomerId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          mastercustomerId: number;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreditCardTokenInputDTO'];
          'text/json': components['schemas']['CreditCardTokenInputDTO'];
          'application/*+json': components['schemas']['CreditCardTokenInputDTO'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/location/{locationid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          locationid: number;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreditCardTokenInputDTO'];
          'text/json': components['schemas']['CreditCardTokenInputDTO'];
          'application/*+json': components['schemas']['CreditCardTokenInputDTO'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          locationid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/creditcard/{franchiseId}/billinggroup/{billinggroupid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          billinggroupid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/deleteunreadablebarcode': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['DeleteWorkOrderScan'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/franchiseinfo': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FranchiseInfo'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/franchiseinfo/{franchiseId}/docs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['FranchiseDocsDTO'];
            'application/json': components['schemas']['FranchiseDocsDTO'];
            'text/json': components['schemas']['FranchiseDocsDTO'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/franchiseinfo/{franchiseId}/upload/{folderName}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          folderName: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'multipart/form-data': {
            /** Format: binary */
            file?: string;
          };
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/logging/log': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/portal/paymentmethods': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CreditCardTokenDTO'][];
            'application/json': components['schemas']['CreditCardTokenDTO'][];
            'text/json': components['schemas']['CreditCardTokenDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PortalPaymentMethodInputDTO'];
          'text/json': components['schemas']['PortalPaymentMethodInputDTO'];
          'application/*+json': components['schemas']['PortalPaymentMethodInputDTO'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CreditCardTokenDTO'];
            'application/json': components['schemas']['CreditCardTokenDTO'];
            'text/json': components['schemas']['CreditCardTokenDTO'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/portal/paymentmethods/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          id: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/user/paymentmethods/{userid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          userid: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CreditCardTokenDTO'][];
            'application/json': components['schemas']['CreditCardTokenDTO'][];
            'text/json': components['schemas']['CreditCardTokenDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/location/{franchiseid}/paymentmethods/{locationid}/setlocation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          locationid: number;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['GuidSimpleRequest'];
          'text/json': components['schemas']['GuidSimpleRequest'];
          'application/*+json': components['schemas']['GuidSimpleRequest'];
        };
      };
      responses: {
        /** @description Accepted */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/guestsale': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['GuestSale'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/customerportalsale': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['CustomerPortalSale'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/renameunreadablebarcode': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['ViewBlob'];
    put?: never;
    post: operations['RenameWorkOrderScan'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/paymentstatusbycustomerreference': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PaymentStatusByCustomerReference'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/paymentstatusbytraceid': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PaymentStatusByTraceId'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/paymentstatusstringbytraceid': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PaymentStatusStringByTraceId'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/paymentstatusstringbycustomerreference': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['PaymentStatusStringByCustomerReference'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/inforeportingaccountlist': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['InfoReportingAccountList'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/inforeportingaccountsdetails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['InfoReportingAccountsDetails'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/inforeportingrecondetails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['InfoReportingReconDetails'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/inforeportingaccounttransactions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['InfoReportingAccountTransactions'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/testauth': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['TestAuth'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/testencrypt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['TestEncrypt'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/testdecrypt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['TestDecrypt'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/testmaskstring': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['TestMaskString'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/upsertfranchisebankdetail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['UpsertFranchiseBankDetail'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getfranchisebankdetails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetFranchiseBankDetails'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getfranchiseoptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetFranchiseOptions'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getroyaltybatches': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetRoyaltyBatches'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/deletefranchisebankdetail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['DeleteFranchiseBankDetail'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getlastroyaltyfiledinfo': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetLastRoyaltyFiledInfo'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getavailableroyaltyperiods': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetAvailableRoyaltyPeriods'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getfranchiseroyalty': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetFranchiseRoyalty'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getfranchiseroyaltybatch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetFranchiseRoyaltyBatch'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/getfranchiseroyaltybatchdetail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetFranchiseRoyaltyBatchDetail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/deletefranchiseroyaltybatch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['DeleteFranchiseRoyaltyBatch'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/upsertfranchiseroyalty': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['UpsertFranchiseRoyalty'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/franchiseroyaltycreateach': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FranchiseRoyaltyCreateACH'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/franchiseroyaltybatchdetail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FranchiseRoyaltyBatchDetail'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/royalties/franchiseroyaltybatch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['FranchiseRoyaltyBatch'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/scheduledprocess/processworkordercc': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['ProcessWorkOrderCC'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/system/probe': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/getfranchiseapicredentials': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: {
          franchiseId?: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/upsertfranchiseapicredentials': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['FranchiseAPICredentials'];
          'text/json': components['schemas']['FranchiseAPICredentials'];
          'application/*+json': components['schemas']['FranchiseAPICredentials'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/paymentformredirect': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['PaymentFormRedirect'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/createtokenfromtransactionforbillinggroup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['CreateTokenFromTransactionForBillingGroup'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/createtokenfromtransactionforcustomer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['CreateTokenFromTransactionForCustomer'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/createtokenfromtransactionforlocation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['CreateTokenFromTransactionForLocation'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/createtokenfromtransaction': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['CreateTokenFromTransaction'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievetoken': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveToken'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/tokenkeysale': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** @deprecated */
    post: operations['TokenKeySale'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/paymentkeysale': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['PaymentKeySale'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/location/{franchiseid}/payments/{locationid}/{userid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          locationid: number;
          userid: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['PaymentDetailDTO'][];
            'application/json': components['schemas']['PaymentDetailDTO'][];
            'text/json': components['schemas']['PaymentDetailDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/getunprocessedcreditcardpayments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['GetUnprocessedCreditCardPayments'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/processpayments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['ProcessPayments'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievespecifcbatch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveSpecifcBatch'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievebatchlist': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveBatchList'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievebatchlistbydaterange': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveBatchListByDateRange'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievebatchtransactions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveBatchTransactions'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievetransactiondetail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveTransactionDetail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievebatchtransactionsfordaterange': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveBatchTransactionsForDateRange'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/matchbatchtransactions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['MatchBatchTransactions'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/usaepay/retrievetransactionmatches': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['RetrieveTransactionMatches'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/register': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['RegisterRequest'];
          'text/json': components['schemas']['RegisterRequest'];
          'application/*+json': components['schemas']['RegisterRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['IdentityResult'];
            'application/json': components['schemas']['IdentityResult'];
            'text/json': components['schemas']['IdentityResult'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['ConfirmRequest'];
          'text/json': components['schemas']['ConfirmRequest'];
          'application/*+json': components['schemas']['ConfirmRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ServiceResponse'];
            'application/json': components['schemas']['ServiceResponse'];
            'text/json': components['schemas']['ServiceResponse'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/resendemailconfirmation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['UserEmailRequest'];
          'text/json': components['schemas']['UserEmailRequest'];
          'application/*+json': components['schemas']['UserEmailRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ServiceResponse'];
            'application/json': components['schemas']['ServiceResponse'];
            'text/json': components['schemas']['ServiceResponse'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/resetpassword': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: {
          email?: string;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ServiceResponse']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/confirmresetpassword': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PasswordConfirmRequest'];
          'text/json': components['schemas']['PasswordConfirmRequest'];
          'application/*+json': components['schemas']['PasswordConfirmRequest'];
        };
      };
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['IdentityResult']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/acceptinvite': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['InvitationConfirmRequest'];
          'text/json': components['schemas']['InvitationConfirmRequest'];
          'application/*+json': components['schemas']['InvitationConfirmRequest'];
        };
      };
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/invitations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['LocationDTO'][];
            'application/json': components['schemas']['LocationDTO'][];
            'text/json': components['schemas']['LocationDTO'][];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['IdentityResult'];
            'application/json': components['schemas']['IdentityResult'];
            'text/json': components['schemas']['IdentityResult'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['UserDTO'];
            'application/json': components['schemas']['UserDTO'];
            'text/json': components['schemas']['UserDTO'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/invoice': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InvoiceDTO'][];
            'application/json': components['schemas']['InvoiceDTO'][];
            'text/json': components['schemas']['InvoiceDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/invoice/{franchiseid}/{documentid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseId: number;
          documentId: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InvoiceDetailDTO'];
            'application/json': components['schemas']['InvoiceDetailDTO'];
            'text/json': components['schemas']['InvoiceDetailDTO'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/invoice/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['UserLocationRequest'];
          'text/json': components['schemas']['UserLocationRequest'];
          'application/*+json': components['schemas']['UserLocationRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['InvoiceDetailDTO'];
            'application/json': components['schemas']['InvoiceDetailDTO'];
            'text/json': components['schemas']['InvoiceDetailDTO'];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/location': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['LocationDTO'][];
            'application/json': components['schemas']['LocationDTO'][];
            'text/json': components['schemas']['LocationDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['UserLocationRequest'];
          'text/json': components['schemas']['UserLocationRequest'];
          'application/*+json': components['schemas']['UserLocationRequest'];
        };
      };
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/location/{locationid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          locationid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/location/{franchiseid}/users/{locationid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          locationid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['UserLocationDTO'][];
            'application/json': components['schemas']['UserLocationDTO'][];
            'text/json': components['schemas']['UserLocationDTO'][];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/location/{franchiseid}/invite/{locationid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: string;
          locationid: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['UserLocationInvitationRequest'];
          'text/json': components['schemas']['UserLocationInvitationRequest'];
          'application/*+json': components['schemas']['UserLocationInvitationRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['UserLocationDTO'][];
            'application/json': components['schemas']['UserLocationDTO'][];
            'text/json': components['schemas']['UserLocationDTO'][];
          };
        };
        /** @description Not Modified */
        304: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/location/{franchiseid}/users/{locationid}/{userid}/{isLocationSpecific}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          locationid: number;
          userid: string;
          isLocationSpecific: boolean;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/workorderrecognitionfailure': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['WorkorderScanFailureController'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/zeptomailwebhook': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** @deprecated */
    post: operations['ZeptomailWebhook'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/zoho/zohowebhook': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'multipart/form-data': {
            data?: string;
          };
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ValidationProblemDetails'];
            'application/json': components['schemas']['ValidationProblemDetails'];
            'text/json': components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/zoho/list/subscribe/estimate/{franchiseid}/{estimateid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          estimateid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/zoho/list/unsubscribe/estimate/{franchiseid}/{estimateid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          franchiseid: number;
          estimateid: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'application/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
            'text/json':
              | components['schemas']['ProblemDetails']
              | components['schemas']['ValidationProblemDetails'];
          };
        };
        /** @description Not Found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['ProblemDetails'];
            'application/json': components['schemas']['ProblemDetails'];
            'text/json': components['schemas']['ProblemDetails'];
          };
        };
        /** @description Internal Server Error */
        500: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'application/json': components['schemas']['ProblemDetails'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    AccessTokenResponse: {
      readonly tokenType: string;
      accessToken: string;
      /** Format: int64 */
      expiresIn: number;
      refreshToken: string;
    };
    AdditionalInfo: {
      type: string;
      reasonCode: string;
      addendaInfo: string;
    };
    AdditionalServiceDTO: {
      /** Format: int32 */
      additionalServiceId: number;
      /** Format: int32 */
      workOrderDetailId: number;
      /** Format: int32 */
      paymentDetailId: number;
      /** Format: double */
      amount: number;
      notes: string | null;
    };
    AuthRequest: {
      userName: string;
      password: string;
      /** Format: int32 */
      franchiseId?: number;
    };
    AuthResult: {
      valid?: boolean;
      sas: string;
      franchiseIds: number[];
    };
    BillingGroupTokenRequest: {
      /** Format: int32 */
      franchiseID?: number;
      tranKey: string;
      /** Format: int32 */
      billingGroupCustomerID?: number;
    };
    CheckPaymentInfo: {
      accountholder: string;
      routing: string;
      account: string;
      account_type: string;
      number?: string | null;
      format: string;
    };
    ConfirmRequest: {
      email: string;
      token: string;
    };
    CreditCardTokenDTO: {
      /** Format: uuid */
      id: string;
      /** Format: int32 */
      creditCardTokenId: number;
      maskedCard: string;
    };
    CreditCardTokenInputDTO: {
      /** Format: int32 */
      franchiseId?: number;
      token: string;
      maskedCard: string;
      avsStreet: string;
      avsPostalCode: string;
      /** Format: int32 */
      creditCardTokenCreateTypeId?: number;
      transactionKey: string;
      /** Format: int32 */
      cardExpiration?: number;
    };
    Creditcard: {
      cardholder?: string | null;
      number: string;
      avs_street?: string | null;
      avs_postalcode?: string | null;
      category_code?: string | null;
      entry_mode?: string | null;
    };
    CustomField: {
      name: string;
      value: string;
    };
    CustomerPortalSaleRequest: {
      /** Format: uuid */
      paymentMethodId?: string | null;
      achInfo?: components['schemas']['CheckPaymentInfo'];
      workOrders: components['schemas']['CustomerPortalWorkOrderRequest'][];
      sendReceipt?: boolean;
      legalAccepted: boolean;
    };
    CustomerPortalWorkOrderRequest: {
      /** Format: int32 */
      franchiseId: number;
      /** Format: int32 */
      workOrderNumber: number;
      additionalServicesNote?: string | null;
      /** Format: double */
      tipAmount: number;
      /** Format: double */
      additionalServiceAmount: number;
    };
    CustomerTokenRequest: {
      /** Format: int32 */
      franchiseID?: number;
      tranKey: string;
      /** Format: int32 */
      customerID?: number;
    };
    EmployeeTipsDTO: {
      /** Format: int32 */
      tipId: number;
      /** Format: date-time */
      date: string;
      /** Format: int32 */
      paymentDocumentId: number;
      /** Format: double */
      amount: number;
      /** Format: double */
      sourceId: number;
      /** Format: int32 */
      tipType: number;
      /** Format: int32 */
      sourcesId: number;
    };
    FranchiseAPICredentials: {
      /** Format: int32 */
      f_FranchiseID?: number;
      f_APIKey: string;
      f_APIPIN: string;
      f_BaseURL: string;
      f_EndPoint: string;
      /** Format: int32 */
      f_UserID?: number | null;
      achEnabled?: boolean;
      customerPortalTipsEnabled?: boolean;
    };
    FranchiseBankDetail: {
      /** Format: int32 */
      f_FranchiseBankDetailID?: number;
      /** Format: int32 */
      f_FranchiseID?: number;
      f_Routing: string;
      f_AccountEncrypted: string;
      f_AccountMasked: string;
      /** Format: int32 */
      f_AccountType?: number;
      /** Format: date-time */
      f_CreateDate?: string;
      /** Format: date-time */
      f_modifedDate?: string;
      /** Format: int32 */
      f_createUserId?: number;
      /** Format: int32 */
      f_modifedUserId?: number;
      createUserName: string;
      modifedUserName: string;
    };
    FranchiseBankDetailDTO: {
      /** Format: int32 */
      franchiseBankDetailID?: number | null;
      /** Format: int32 */
      franchiseID?: number;
      routing: string;
      account: string;
      /** Format: int32 */
      accountType?: number;
      /** Format: date-time */
      createDate?: string;
      /** Format: date-time */
      modifedDate?: string | null;
      /** Format: int32 */
      modifiedUserId?: number;
      /** Format: int32 */
      createUserId?: number;
      modifedUserName?: string | null;
      createUserName?: string | null;
    };
    FranchiseDocsDTO: {
      /** Format: int32 */
      franchiseId?: number;
      w9Url?: string | null;
      coiUrl?: string | null;
    };
    FranchiseInfoRequest: {
      /** Format: int32 */
      franchiseId: number;
    };
    FranchiseInfoResult: {
      valid?: boolean;
      message: string;
      /** Format: int32 */
      franchiseId?: number;
      franchiseName: string;
      franchiseEmail: string;
      authHash: string;
    };
    FranchiseOptionsDTO: {
      displayName: string;
      /** Format: int32 */
      franchiseID?: number;
    };
    FranchiseRoyalty: {
      /** Format: int32 */
      f_franchiseID?: number;
      f_Franchise_TerritoryDescription: string;
      f_Franchise_CompanyName: string;
      f_routing: string;
      f_accountMasked: string;
      f_Royalty_InstructionId?: string | null;
      f_Royalty_MultipaymentId?: string | null;
      f_Branding_InstructionId?: string | null;
      f_Branding_MultipaymentId?: string | null;
      f_Tech_Fee_InstructionId?: string | null;
      f_Tech_Fee_MultipaymentId?: string | null;
      /** Format: double */
      sales?: number;
      /** Format: double */
      royalty?: number;
      /** Format: double */
      branding?: number;
      /** Format: double */
      tech_Fee?: number;
      /** Format: double */
      chargedSales?: number;
      /** Format: int32 */
      royaltyWeeklyDetailId?: number;
      /** Format: int32 */
      week_Id?: number;
      /** Format: int32 */
      royaltyPeriod?: number;
      f_Royalty_ACH_TraceId?: string | null;
      f_Royalty_ACH_CustRef?: string | null;
      f_Royalty_ACH_Status?: string | null;
      f_Branding_ACH_TraceId?: string | null;
      f_Branding_ACH_CustRef?: string | null;
      f_Branding_ACH_Status?: string | null;
      f_Tech_Fee_ACH_TraceId?: string | null;
      f_Tech_Fee_ACH_CustRef?: string | null;
      f_Tech_Fee_ACH_Status?: string | null;
      /** Format: int32 */
      f_RoyaltyBatchID?: number | null;
      /** Format: date-time */
      f_ACHSubmitDate?: string | null;
    };
    FranchiseRoyaltyDTO: {
      /** Format: int32 */
      f_franchiseID?: number;
      f_Franchise_TerritoryDescription: string;
      f_Franchise_CompanyName: string;
      f_routing: string;
      f_accountMasked: string;
      f_Royalty_InstructionId?: string | null;
      f_Royalty_MultipaymentId?: string | null;
      f_Branding_InstructionId?: string | null;
      f_Branding_MultipaymentId?: string | null;
      f_Tech_Fee_InstructionId?: string | null;
      f_Tech_Fee_MultipaymentId?: string | null;
      /** Format: double */
      sales?: number;
      /** Format: double */
      royalty?: number;
      /** Format: double */
      branding?: number;
      /** Format: double */
      tech_Fee?: number;
      /** Format: double */
      chargedSales?: number;
      /** Format: int32 */
      royaltyWeeklyDetailId?: number;
      /** Format: int32 */
      week_Id?: number;
      /** Format: int32 */
      royaltyPeriod?: number;
      f_Royalty_ACH_TraceId?: string | null;
      f_Royalty_ACH_CustRef?: string | null;
      f_Royalty_ACH_Status?: string | null;
      f_Branding_ACH_TraceId?: string | null;
      f_Branding_ACH_CustRef?: string | null;
      f_Branding_ACH_Status?: string | null;
      f_Tech_Fee_ACH_TraceId?: string | null;
      f_Tech_Fee_ACH_CustRef?: string | null;
      f_Tech_Fee_ACH_Status?: string | null;
      /** Format: int32 */
      f_RoyaltyBatchID?: number | null;
      /** Format: date-time */
      f_ACHSubmitDate?: string | null;
      description?: string | null;
      changeDescription?: string | null;
    };
    GuestSaleRequest: {
      /** Format: int32 */
      franchiseId: number;
      /** Format: int32 */
      workOrderNumber: number;
      additionalServicesNote?: string | null;
      /** Format: double */
      tipAmount: number;
      /** Format: double */
      additionalServiceAmount: number;
      paymentKey?: string | null;
      achInfo?: components['schemas']['CheckPaymentInfo'];
      firstName: string;
      lastName: string;
      email: string;
      phone: string;
      address: string;
      address2: string;
      city: string;
      state: string;
      postalCode: string;
      sendReceipt?: boolean;
      legalAccepted: boolean;
    };
    GuidSimpleRequest: {
      /** Format: uuid */
      value: string;
    };
    IdentityError: {
      code: string;
      description: string;
    };
    IdentityResult: {
      readonly succeeded?: boolean;
      readonly errors: components['schemas']['IdentityError'][];
    };
    InvitationConfirmRequest: {
      email: string;
      passwordToken: string;
      password: string;
      firstName: string;
      lastName: string;
    };
    InvoiceDTO: {
      /** Format: int32 */
      documentId: number;
      /** Format: date-time */
      documentDate: string;
      /** Format: int32 */
      franchiseId: number;
      /** Format: int32 */
      documentTypeId: number;
      /** Format: int32 */
      documentStatusTypeId: number;
      /** Format: int32 */
      workOrderNumber: number;
      /** Format: double */
      amount: number;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      state: string | null;
      zipCode: string | null;
      /** Format: date-time */
      completedDate: string | null;
      /** Format: date-time */
      dueDate: string | null;
      isTaxed: boolean;
      /** Format: double */
      paidAmount: number;
      pdfLink: string;
      readonly pngLink: string;
      tipsEnabled: boolean;
      achEnabled: boolean;
      /** Format: double */
      readonly salesTaxRate: number;
      /** Format: double */
      readonly salesTaxAmount: number;
      /** Format: double */
      readonly balanceDue: number;
      workOrders: components['schemas']['InvoiceWorkOrder'][];
    };
    InvoiceDetailDTO: {
      /** Format: int32 */
      documentId: number;
      /** Format: date-time */
      documentDate: string;
      /** Format: int32 */
      franchiseId: number;
      /** Format: int32 */
      documentTypeId: number;
      /** Format: int32 */
      documentStatusTypeId: number;
      /** Format: int32 */
      workOrderNumber: number;
      /** Format: double */
      amount: number;
      addressLine1: string | null;
      addressLine2: string | null;
      city: string | null;
      state: string | null;
      zipCode: string | null;
      /** Format: date-time */
      completedDate: string | null;
      /** Format: date-time */
      dueDate: string | null;
      isTaxed: boolean;
      /** Format: double */
      paidAmount: number;
      pdfLink: string;
      readonly pngLink: string;
      tipsEnabled: boolean;
      achEnabled: boolean;
      /** Format: double */
      readonly salesTaxRate: number;
      /** Format: double */
      readonly salesTaxAmount: number;
      /** Format: double */
      readonly balanceDue: number;
      workOrders: components['schemas']['InvoiceWorkOrder'][];
      payments: components['schemas']['PaymentDetailDTO'][];
      tips: components['schemas']['EmployeeTipsDTO'][];
      additionalServices: components['schemas']['AdditionalServiceDTO'][];
      publicKey: string;
    };
    InvoiceWorkOrder: {
      /** Format: int32 */
      documentId: number;
      /** Format: int32 */
      workOrderDetailId: number;
      /** Format: date-time */
      workOrderDetailDate: string;
      /** Format: int32 */
      customerId: number;
      /** Format: int32 */
      locationId: number;
      /** Format: double */
      amount: number;
      /** Format: int32 */
      jobId: number;
      /** Format: int32 */
      jobComponentId: number;
      /** Format: int32 */
      weekId: number;
      /** Format: int32 */
      payMethodId: number;
      /** Format: int32 */
      reconcileWeekId: number;
      jobComponentGround: boolean;
      /** Format: int32 */
      calendarYear?: number | null;
      /** Format: double */
      salesTaxAmount: number;
      /** Format: double */
      salesTaxRate: number;
    };
    LastRoyaltyFiledInfoDTO: {
      /** Format: int32 */
      wbI_Id?: number;
      wbI_Period: string;
      /** Format: date-time */
      royaltyWeekStartDate?: string;
      /** Format: date-time */
      royaltyWeekEndDate?: string;
    };
    LocationDTO: {
      /** Format: int32 */
      locationId?: number;
      description?: string | null;
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      state?: string | null;
      zipCode?: string | null;
      customerName: string;
      legalAccepted: boolean;
    };
    LocationTokenRequest: {
      /** Format: int32 */
      franchiseID?: number;
      tranKey: string;
      /** Format: int32 */
      locationID?: number;
    };
    LoginRequest: {
      email: string;
      password: string;
    };
    PNCPaymentStatusByTraceIdResponse: {
      customerReference: string;
      executedPaymentType: string;
      instructionId: string;
      multipaymentId: string;
      preferredPaymentType: string;
      statusCode: string;
      statusDesc: string;
      /** Format: date-time */
      timestamp?: string;
      traceId: string;
      transferAmount: components['schemas']['Transferamount'];
    };
    PNCPaymentStatusItem: {
      statusCode: string;
      statusDesc: string;
      /** Format: date-time */
      timestamp?: string;
      multipaymentId: string;
      instructionId: string;
      traceId: string;
      customerReference: string;
      executedPaymentType: string;
      paymentReference: string;
      preferredPaymentType: string;
      additionalInfo: components['schemas']['AdditionalInfo'][];
      transferAmount: components['schemas']['TransferAmount'];
    };
    PNCPaymentStatusResponse: {
      data: components['schemas']['PNCPaymentStatusItem'][];
    };
    PNCTransactionRefs: {
      transactionRefNums: components['schemas']['Transactionrefnum'][];
    };
    PasswordConfirmRequest: {
      email: string;
      passwordToken: string;
      password: string;
    };
    PaymentDTO: {
      /** Format: date-time */
      reconciliationWorkOrderDetailDate?: string | null;
      /** Format: double */
      workOrderBalanceDue?: number;
      /** Format: double */
      tipAmount?: number;
      /** Format: int32 */
      workOrderNumber?: number;
      workOrderNumberDisplay?: string | null;
      /** Format: int32 */
      reconciliationWorkOrderDetailDocumentId?: number;
      /** Format: int32 */
      locationId?: number;
      locationDescription: string;
      /** Format: int32 */
      customerId?: number;
      customerName: string;
      workOrderCreditCardTokenDescription: string;
      /** Format: int32 */
      workOrderCreditCardTokenId?: number | null;
      check?: components['schemas']['CheckPaymentInfo'];
      /** Format: double */
      reconciledWorkOrderTipAmount?: number;
      /** Format: int32 */
      customerBillingGroupCounti?: number;
      sendPaymentNotificationEmail?: boolean;
      customerEmail?: string | null;
    };
    PaymentDetailDTO: {
      /** Format: int32 */
      paymentDetailId: number;
      /** Format: date-time */
      paymentDate: string;
      /** Format: int32 */
      customerId: number;
      /** Format: int32 */
      documentId: number;
      /** Format: double */
      amount: number;
      confirmationNumber: string;
      paymentReversed: boolean;
      type: components['schemas']['PaymentReceivedTypeDTO'];
    };
    PaymentKeySale: {
      command: string;
      invoice: string;
      ponum: string;
      description: string;
      comments: string;
      amount: string;
      payment_key: string;
    };
    PaymentReceivedTypeDTO: {
      /** Format: int32 */
      typeId: number | null;
      code: string | null;
      description: string | null;
    };
    /**
     * Format: int32
     * @enum {integer}
     */
    PaymentType: PaymentType;
    PaymentsInputDTO: {
      /** Format: int32 */
      userId?: number;
      /** Format: int32 */
      franchiseId?: number;
      source?: components['schemas']['TransactionPaymentSource'];
      submitAsSingleTransaction?: boolean;
      creditCardPaymentsDtos: components['schemas']['PaymentDTO'][];
      paymentType?: components['schemas']['PaymentType'];
    };
    PortalPaymentMethodInputDTO: {
      paymentKey: string;
      maskedCard: string;
      street: string;
      postalCode: string;
    };
    ProblemDetails: {
      type?: string | null;
      title?: string | null;
      /** Format: int32 */
      status?: number | null;
      detail?: string | null;
      instance?: string | null;
    };
    RefreshRequest: {
      refreshToken: string;
    };
    RegisterRequest: {
      email: string;
      firstName: string;
      lastName: string;
      password: string;
      userType?: components['schemas']['UserType'];
    };
    RoyaltyBatchesDTO: {
      displayName: string;
      /** Format: int32 */
      royaltyBatchID?: number;
      /** Format: int32 */
      royaltyPeriod?: number;
      /** Format: date-time */
      royaltyWeek?: string;
      achSubmitted?: boolean;
      /** Format: int32 */
      achSubmitUserId?: number | null;
      /** Format: date-time */
      achSubmitDate?: string | null;
      achStaged?: boolean;
      /** Format: int32 */
      achStagedUserId?: number | null;
      /** Format: date-time */
      achStagedDate?: string | null;
      /** Format: date-time */
      achExecutionDate?: string | null;
    };
    RoyaltyPeriodsDTO: {
      /** Format: int32 */
      period?: number;
      /** Format: date-time */
      week?: string;
      readonly optionText: string;
    };
    SasTokenResult: {
      valid?: boolean;
      message: string;
      sasToken: string;
    };
    ServiceResponse: {
      isSuccess?: boolean;
      message: string;
    };
    TokenSale: {
      command: string;
      invoice: string;
      ponum: string;
      description: string;
      comments: string;
      amount: string;
      send_receipt?: boolean;
      email: string;
      'receipt-custemail': string;
      custom_fields: components['schemas']['CustomField'][];
      creditcard: components['schemas']['Creditcard'];
    };
    /**
     * Format: int32
     * @enum {integer}
     */
    TransactionPaymentSource: TransactionPaymentSource;
    /**
     * Format: int32
     * @enum {integer}
     */
    TransactionPaymentStatus: TransactionPaymentStatus;
    Transactionrefnum: {
      transactionRefNum: string;
      /** Format: date-time */
      transactionTimestamp?: string;
    };
    TransferAmount: {
      amount: string;
      currency: string;
    };
    Transferamount: {
      amount: string;
      currency: string;
    };
    /**
     * Format: int32
     * @enum {integer}
     */
    UnRecognizedStatus: UnRecognizedStatus;
    UnprocessedCreditCardPaymentDto: {
      paymentStatus?: components['schemas']['TransactionPaymentStatus'];
      paymentStatusDescription: string;
      creditCardPaymentDto: components['schemas']['PaymentDTO'];
    };
    UnreadableBarcodeRenameRequest: {
      blobNewName: string;
      blobName: string;
      franchiseId: string;
      /** Format: int64 */
      f_admin_WorkOrderScanRecognitionFailureID?: number;
      /** Format: int64 */
      f_UserID?: number;
      unRecognizedStatus?: components['schemas']['UnRecognizedStatus'];
    };
    UserDTO: {
      /** Format: uuid */
      id?: string;
      email: string;
      firstName: string;
      lastName: string;
      /** Format: date-time */
      createdOn?: string;
      /** Format: date-time */
      lastLoginOn?: string | null;
    };
    UserEmailRequest: {
      email: string;
    };
    UserLocationDTO: {
      user: components['schemas']['UserDTO'];
      location: components['schemas']['LocationDTO'];
      isAccepted: boolean;
    };
    UserLocationInvitationRequest: {
      email: string;
      /** Format: int32 */
      locationId: number;
      /** Format: int32 */
      franchiseId: number;
    };
    UserLocationRequest: {
      /** Format: int32 */
      franchiseId: number;
      /** Format: int32 */
      workOrderNumber: number;
      zipCode: string;
    };
    /**
     * Format: int32
     * @enum {integer}
     */
    UserType: UserType;
    ValidationProblemDetails: {
      type?: string | null;
      title?: string | null;
      /** Format: int32 */
      status?: number | null;
      detail?: string | null;
      instance?: string | null;
      errors: {
        [key: string]: string[];
      };
    };
    WorkOrderRecognitionFailure: {
      /** Format: int32 */
      f_WorkOrderScanFailureID?: number;
      /** Format: int32 */
      f_FranchiseID?: number;
      /** Format: date-time */
      f_CreateDate?: string;
      /** Format: date-time */
      f_ModifiedDate?: string;
      /** Format: int32 */
      f_Status?: number;
      f_Filename: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  DeleteWorkOrderScan: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UnreadableBarcodeRenameRequest'];
        'text/json': components['schemas']['UnreadableBarcodeRenameRequest'];
        'application/*+json': components['schemas']['UnreadableBarcodeRenameRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': boolean;
          'application/json': boolean;
          'text/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  FranchiseInfo: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FranchiseInfoRequest'];
        'text/json': components['schemas']['FranchiseInfoRequest'];
        'application/*+json': components['schemas']['FranchiseInfoRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseInfoResult'];
          'application/json': components['schemas']['FranchiseInfoResult'];
          'text/json': components['schemas']['FranchiseInfoResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GuestSale: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['GuestSaleRequest'];
        'text/json': components['schemas']['GuestSaleRequest'];
        'application/*+json': components['schemas']['GuestSaleRequest'];
      };
    };
    responses: {
      /** @description Accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
          'application/json':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
          'text/json':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ProblemDetails'];
          'application/json': components['schemas']['ProblemDetails'];
          'text/json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  CustomerPortalSale: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['CustomerPortalSaleRequest'];
        'text/json': components['schemas']['CustomerPortalSaleRequest'];
        'application/*+json': components['schemas']['CustomerPortalSaleRequest'];
      };
    };
    responses: {
      /** @description Accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
          'application/json':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
          'text/json':
            | components['schemas']['ProblemDetails']
            | components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ProblemDetails'];
          'application/json': components['schemas']['ProblemDetails'];
          'text/json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ViewBlob: {
    parameters: {
      query?: {
        blobName?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RenameWorkOrderScan: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UnreadableBarcodeRenameRequest'];
        'text/json': components['schemas']['UnreadableBarcodeRenameRequest'];
        'application/*+json': components['schemas']['UnreadableBarcodeRenameRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': boolean;
          'application/json': boolean;
          'text/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentStatusByCustomerReference: {
    parameters: {
      query?: {
        CustomerReference?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['PNCPaymentStatusResponse'];
          'application/json': components['schemas']['PNCPaymentStatusResponse'];
          'text/json': components['schemas']['PNCPaymentStatusResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentStatusByTraceId: {
    parameters: {
      query?: {
        TraceId?: string;
        multipaymentId?: string;
        instructionId?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['PNCPaymentStatusByTraceIdResponse'];
          'application/json': components['schemas']['PNCPaymentStatusByTraceIdResponse'];
          'text/json': components['schemas']['PNCPaymentStatusByTraceIdResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentStatusStringByTraceId: {
    parameters: {
      query?: {
        TraceId?: string;
        multipaymentId?: string;
        instructionId?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentStatusStringByCustomerReference: {
    parameters: {
      query?: {
        CustomerReference?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  InfoReportingAccountList: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  InfoReportingAccountsDetails: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  InfoReportingReconDetails: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PNCTransactionRefs'];
        'text/json': components['schemas']['PNCTransactionRefs'];
        'application/*+json': components['schemas']['PNCTransactionRefs'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  InfoReportingAccountTransactions: {
    parameters: {
      query?: {
        StartDate?: string;
        EndDate?: string;
        Account?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  TestAuth: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  TestEncrypt: {
    parameters: {
      query?: {
        initialText?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  TestDecrypt: {
    parameters: {
      query?: {
        cypherText?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  TestMaskString: {
    parameters: {
      query?: {
        originalText?: string;
        maskCharacter?: string;
        clearCount?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': string;
          'application/json': string;
          'text/json': string;
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  UpsertFranchiseBankDetail: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FranchiseBankDetailDTO'][];
        'text/json': components['schemas']['FranchiseBankDetailDTO'][];
        'application/*+json': components['schemas']['FranchiseBankDetailDTO'][];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseBankDetail'][];
          'application/json': components['schemas']['FranchiseBankDetail'][];
          'text/json': components['schemas']['FranchiseBankDetail'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFranchiseBankDetails: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseBankDetailDTO'][];
          'application/json': components['schemas']['FranchiseBankDetailDTO'][];
          'text/json': components['schemas']['FranchiseBankDetailDTO'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFranchiseOptions: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseOptionsDTO'][];
          'application/json': components['schemas']['FranchiseOptionsDTO'][];
          'text/json': components['schemas']['FranchiseOptionsDTO'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetRoyaltyBatches: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['RoyaltyBatchesDTO'][];
          'application/json': components['schemas']['RoyaltyBatchesDTO'][];
          'text/json': components['schemas']['RoyaltyBatchesDTO'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeleteFranchiseBankDetail: {
    parameters: {
      query?: {
        id?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetLastRoyaltyFiledInfo: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['LastRoyaltyFiledInfoDTO'];
          'application/json': components['schemas']['LastRoyaltyFiledInfoDTO'];
          'text/json': components['schemas']['LastRoyaltyFiledInfoDTO'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetAvailableRoyaltyPeriods: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['RoyaltyPeriodsDTO'][];
          'application/json': components['schemas']['RoyaltyPeriodsDTO'][];
          'text/json': components['schemas']['RoyaltyPeriodsDTO'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFranchiseRoyalty: {
    parameters: {
      query?: {
        periodId?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseRoyalty'][];
          'application/json': components['schemas']['FranchiseRoyalty'][];
          'text/json': components['schemas']['FranchiseRoyalty'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFranchiseRoyaltyBatch: {
    parameters: {
      query?: {
        id?: number;
        userId?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseRoyalty'][];
          'application/json': components['schemas']['FranchiseRoyalty'][];
          'text/json': components['schemas']['FranchiseRoyalty'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFranchiseRoyaltyBatchDetail: {
    parameters: {
      query?: {
        id?: number;
        franchiseId?: number;
        userId?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['FranchiseRoyalty'];
          'application/json': components['schemas']['FranchiseRoyalty'];
          'text/json': components['schemas']['FranchiseRoyalty'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeleteFranchiseRoyaltyBatch: {
    parameters: {
      query?: {
        id?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': boolean;
          'application/json': boolean;
          'text/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  UpsertFranchiseRoyalty: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FranchiseRoyalty'];
        'text/json': components['schemas']['FranchiseRoyalty'];
        'application/*+json': components['schemas']['FranchiseRoyalty'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  FranchiseRoyaltyCreateACH: {
    parameters: {
      query?: {
        UserID?: number;
        ACHDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FranchiseRoyaltyDTO'][];
        'text/json': components['schemas']['FranchiseRoyaltyDTO'][];
        'application/*+json': components['schemas']['FranchiseRoyaltyDTO'][];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  FranchiseRoyaltyBatchDetail: {
    parameters: {
      query?: {
        batchID?: number;
        UserID?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FranchiseRoyaltyDTO'][];
        'text/json': components['schemas']['FranchiseRoyaltyDTO'][];
        'application/*+json': components['schemas']['FranchiseRoyaltyDTO'][];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  FranchiseRoyaltyBatch: {
    parameters: {
      query?: {
        batchID?: number;
        UserID?: number;
        ExecutionDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ProcessWorkOrderCC: {
    parameters: {
      query?: {
        reconciliationDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentFormRedirect: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  CreateTokenFromTransactionForBillingGroup: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BillingGroupTokenRequest'];
        'text/json': components['schemas']['BillingGroupTokenRequest'];
        'application/*+json': components['schemas']['BillingGroupTokenRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  CreateTokenFromTransactionForCustomer: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['CustomerTokenRequest'];
        'text/json': components['schemas']['CustomerTokenRequest'];
        'application/*+json': components['schemas']['CustomerTokenRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  CreateTokenFromTransactionForLocation: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['LocationTokenRequest'];
        'text/json': components['schemas']['LocationTokenRequest'];
        'application/*+json': components['schemas']['LocationTokenRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  CreateTokenFromTransaction: {
    parameters: {
      query?: {
        FranchiseID?: number;
        TranKey?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveToken: {
    parameters: {
      query?: {
        FranchiseID?: number;
        Token?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  TokenKeySale: {
    parameters: {
      query?: {
        FranchiseID?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['TokenSale'];
        'text/json': components['schemas']['TokenSale'];
        'application/*+json': components['schemas']['TokenSale'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PaymentKeySale: {
    parameters: {
      query?: {
        FranchiseID?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PaymentKeySale'];
        'text/json': components['schemas']['PaymentKeySale'];
        'application/*+json': components['schemas']['PaymentKeySale'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetUnprocessedCreditCardPayments: {
    parameters: {
      query?: {
        franchiseId?: number;
        reconciliationDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['UnprocessedCreditCardPaymentDto'][];
          'application/json': components['schemas']['UnprocessedCreditCardPaymentDto'][];
          'text/json': components['schemas']['UnprocessedCreditCardPaymentDto'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ProcessPayments: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PaymentsInputDTO'];
        'text/json': components['schemas']['PaymentsInputDTO'];
        'application/*+json': components['schemas']['PaymentsInputDTO'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveSpecifcBatch: {
    parameters: {
      query?: {
        FranchiseID?: number;
        BatchKey?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveBatchList: {
    parameters: {
      query?: {
        FranchiseID?: number;
        Limit?: number;
        Offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveBatchListByDateRange: {
    parameters: {
      query?: {
        FranchiseID?: number;
        StartDate?: string;
        EndDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveBatchTransactions: {
    parameters: {
      query?: {
        FranchiseID?: number;
        BatchKey?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveTransactionDetail: {
    parameters: {
      query?: {
        FranchiseID?: number;
        TransactionKey?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveBatchTransactionsForDateRange: {
    parameters: {
      query?: {
        FranchiseID?: number;
        StartDate?: string;
        EndDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  MatchBatchTransactions: {
    parameters: {
      query?: {
        FranchiseID?: number;
        BatchKey?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  RetrieveTransactionMatches: {
    parameters: {
      query?: {
        franchiseId?: number;
        StartDate?: string;
        EndDate?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  WorkorderScanFailureController: {
    parameters: {
      query?: {
        SharedSecret?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['WorkOrderRecognitionFailure'];
        'text/json': components['schemas']['WorkOrderRecognitionFailure'];
        'application/*+json': components['schemas']['WorkOrderRecognitionFailure'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ZeptomailWebhook: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'multipart/form-data': {
          data?: string;
        };
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': components['schemas']['ValidationProblemDetails'];
          'application/json': components['schemas']['ValidationProblemDetails'];
          'text/json': components['schemas']['ValidationProblemDetails'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
}
export enum PaymentType {
  CreditCard = 4,
  ACH = 8,
}
export enum TransactionPaymentSource {
  AlertPage = 1,
  CustomerPaymentPage = 2,
  MonthlyRecurringProcess = 3,
  CustomerPayOnline = 4,
  DailyAutomatedProcess = 5,
}
export enum TransactionPaymentStatus {
  Processed = 0,
  Approved = 1,
  PartialApproval = 2,
  Declined = 3,
  Error = 4,
  VerificationRequired = 5,
  Unprocessed = -1,
}
export enum UnRecognizedStatus {
  AllowDeleteOrRename = 0,
  Renamed = 1,
  AllowDelete = 2,
  Deleted = 3,
}
export enum UserType {
  Admin = 1,
  User = 2,
  Franchise = 3,
}
